export const smartphone = {
  name: "smartphone" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M5.6 3c0-1.05.85-1.9 1.9-1.9h9c1.05 0 1.9.85 1.9 1.9v17.5a1.9 1.9 0 0 1-1.9 1.9h-9a1.9 1.9 0 0 1-1.9-1.9V3Zm1.8 0v17.5a.1.1 0 0 0 .1.1h9a.1.1 0 0 0 .1-.1V3a.1.1 0 0 0-.1-.1h-9a.1.1 0 0 0-.1.1Zm3.2 16a.9.9 0 0 1 .9-.9h1a.9.9 0 1 1 0 1.8h-1a.9.9 0 0 1-.9-.9Z" clip-rule="evenodd"/></svg>`,
  keywords: ["smartphone"],
  category: "device" as const,
};
